import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ObservationDefinition } from 'app/mdm/lib/observation-definition/observation-definition';
import { ObservationDefinitionService } from 'app/mdm/lib/observation-definition/services/observation-definition.service';
import { ComponentStateStore, SearchResult } from '@heda/core-util';
import { ObservationDefinitionSearchParams } from 'app/mdm/lib/observation-definition/observation-definition-search-params';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'observation-definition-list.component.html',
})
export class ObservationDefinitionListComponent implements OnInit {
  public editPrivileges = ['mdm.terminology.edit'];
  public viewPrivileges = ['mdm.terminology.view'];

  public definitions: SearchResult<ObservationDefinition>;
  public query: ObservationDefinitionSearchParams;
  public loading: boolean;
  public search: string;
  private STORE_KEY = 'observation-definition-list';

  @ViewChild('importDefinitionInp') public importDefinitionInp: ElementRef;

  constructor(
    private observationDefinitionService: ObservationDefinitionService,
    private stateStore: ComponentStateStore,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.definitions = SearchResult.empty();
    const state = this.stateStore.pop(this.STORE_KEY);
    this.query = state ? state.query : this.initialParams();
    this.search = this.query.text ? this.query.text.split('|')[1] : '';
    this.loadDefinitions();
  }

  public loadDefinitions(): void {
    this.query.text = `${this.translateService.currentLang}|${this.search}`;
    this.stateStore.put(this.STORE_KEY, { query: this.query });
    this.loading = true;
    this.observationDefinitionService
      .search(this.query)
      .subscribe((resp) => {
        this.definitions = resp;
      })
      .add(() => (this.loading = false));
  }

  public initialParams(): ObservationDefinitionSearchParams {
    this.search = '';
    const p = new ObservationDefinitionSearchParams();
    p.sort = 'name|' + this.translateService.currentLang;
    p.date = new Date();
    return p;
  }

  public importObservationDefinition(): void {
    this.importDefinitionInp.nativeElement.click();
  }

  public readFile(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.readAsText(file, 'UTF-8');
    fileReader.onload = () => {
      const input = JSON.parse(fileReader.result as string);
      this.observationDefinitionService.import(input).subscribe((resp) => this.loadDefinitions());
    };
  }
}
